module.exports = __webpack_public_path__ + "img/30_31.0b91a9dd.png";